import { isEmpty as A } from "../../utils/isEmpty.js";
import { isObject as a } from "../../utils/isObject.js";
import { tryParseNumber as y } from "../../utils/tryParseNumber.js";
import { FORM_VALID as o } from "./Form.constant.js";
function x(r) {
  return r !== o;
}
function V(r) {
  if (!r)
    return [];
  if (typeof r == "function")
    return [r];
  if (typeof r == "object")
    return Array.isArray(r) ? r : Object.values(r);
  throw new Error(
    `Expecting a function, an object or an array, got ${r}`
  );
}
function F(r = {}, e = {}) {
  return function(n, i, c) {
    const p = V(
      r[n] ?? []
    );
    try {
      for (const u of p) {
        const s = u(i, c, e);
        if (s !== o)
          return s;
      }
      return o;
    } catch (u) {
      return String(u);
    }
  };
}
const f = (r, e, t, ...n) => typeof r == "function" ? r(e, t, ...n) : r, E = (r) => {
  switch (typeof r) {
    case "number":
      return Number.isNaN(r);
    case "boolean":
      return !1;
    default:
      return A(r);
  }
};
function I(r) {
  return (e, t, n) => E(e) ? f(r, e, t, n) : o;
}
function L(r, e) {
  return (t, n, i) => typeof t == "string" && (t === "" || t.length >= r) ? o : f(e, t, n, r, i);
}
function M(r, e) {
  return (t, n, i) => typeof t == "string" && (t === "" || t.length <= r) ? o : f(e, t, n, r, i);
}
const N = (r) => typeof r == "number" && !Number.isNaN(r);
function k(r, e) {
  return (t, n, i) => N(t) && t >= r ? o : f(e, t, n, r, i);
}
function T(r, e) {
  return (t, n, i) => N(t) && t <= r ? o : f(e, t, n, r, i);
}
function h(r) {
  return Array.isArray(r[0]);
}
function q(r, e) {
  return (t, n, i) => (Number.isNaN(t) || typeof t != "number") && typeof t != "string" ? f(e, t, n, r, i) : (h(r) ? r : [r]).some(([u, s]) => {
    const g = y(u), b = y(s), m = y(t);
    return g === null || b === null || m === null ? !1 : m >= g && m <= b;
  }) ? o : f(e, t, n, r, i);
}
function D(r, e) {
  return (t, n, i) => !r && !t || r && t === !0 ? o : f(e, t, n, i);
}
function P(r, e) {
  return (t, n, i) => typeof t == "string" && (t === "" || r.test(t)) ? o : f(e, t, n, r, i);
}
function S(r, e) {
  return (t, n, i) => typeof t == "string" && (t === "" || !r.test(t)) ? o : f(e, t, n, r, i);
}
const R = (r, e) => {
  if (A(e))
    return r;
  const t = { ...r };
  for (const [n, i] of Object.entries(e)) {
    const c = t[n];
    Array.isArray(c) && Array.isArray(i) ? t[n] = i : a(c) && a(i) ? t[n] = R(c, i) : t[n] = i;
  }
  return t;
};
export {
  D as booleanValue,
  f as formatErrorMessage,
  x as isError,
  F as makeValidate,
  P as matchingRegExp,
  T as max,
  M as maxLength,
  R as mergeFormValues,
  k as min,
  L as minLength,
  S as missingRegExp,
  q as range,
  I as required
};
